import store from '../../..';
import { TApiaFilter } from '../../../../types';
import { makeCustomEvent } from '../../../../utils/dom';
import { TApiaFinderFilter } from '../../types';

export default function notifyRequiredFilters(
  listId: string,
  newFilters?: TApiaFinderFilter[],
): TApiaFinderFilter[] {
  // Hallar todos los filtros requeridos sin valor
  // Hacer update de cada uno

  // Helper function to check if a value is empty (undefined or empty string)
  const isEmpty = (value: any) => value === undefined || value === '';

  // Helper function to add or remove error based on condition
  const setError = (
    filter: TApiaFinderFilter,
    errorField: keyof TApiaFilter,
    condition: boolean,
    errorMessage: string = '',
  ): TApiaFinderFilter => {
    return {
      ...filter,
      apiaFilter: {
        ...filter.apiaFilter,
        [errorField]: condition ? errorMessage : undefined,
      },
    };
  };
  const missingFilters: TApiaFinderFilter[] =
    (newFilters
      ? newFilters.map((innerFilter) => {
          if (['date', 'D'].includes(innerFilter.apiaFilter.type as string)) {
            const { apiaFilter } = innerFilter;

            if (apiaFilter.required) {
              if (
                apiaFilter.dateFromRequired &&
                isEmpty(apiaFilter.currentValue)
              ) {
                return setError(
                  innerFilter,
                  'errorFrom',
                  true,
                  'Filtro requerido',
                );
              } else if (
                apiaFilter.dateRequired &&
                isEmpty(apiaFilter.currentValue) &&
                isEmpty(apiaFilter.filterToValue)
              ) {
                return setError(innerFilter, 'error', true, 'Filtro requerido');
              } else if (
                apiaFilter.dateToRequired &&
                isEmpty(apiaFilter.filterToValue)
              ) {
                return setError(
                  innerFilter,
                  'errorTo',
                  true,
                  'Filtro requerido',
                );
              } else if (
                apiaFilter.dateFromRequired &&
                !isEmpty(apiaFilter.currentValue)
              ) {
                return setError(innerFilter, 'errorFrom', false);
              } else if (
                apiaFilter.dateRequired &&
                !isEmpty(apiaFilter.currentValue) &&
                !isEmpty(apiaFilter.filterToValue)
              ) {
                return setError(innerFilter, 'error', false);
              } else if (
                apiaFilter.dateToRequired &&
                !isEmpty(apiaFilter.filterToValue)
              ) {
                return setError(innerFilter, 'errorTo', false);
              } else {
                return innerFilter;
              }
            } else {
              return innerFilter;
            }
          } else {
            const { apiaFilter } = innerFilter;

            if (apiaFilter.required) {
              if (isEmpty(apiaFilter.currentValue)) {
                return setError(innerFilter, 'error', true, 'Filtro requerido');
              } else {
                return setError(innerFilter, 'error', false);
              }
            } else {
              return innerFilter;
            }
          }
        })
      : store
          .getState()
          .querySlice.queries[listId].filters?.map((innerFilter) => {
            if (['date', 'D'].includes(innerFilter.apiaFilter.type as string)) {
              const { apiaFilter } = innerFilter;

              if (apiaFilter.required) {
                if (
                  apiaFilter.dateFromRequired &&
                  isEmpty(apiaFilter.currentValue)
                ) {
                  return setError(
                    innerFilter,
                    'errorFrom',
                    true,
                    'Filtro requerido',
                  );
                } else if (
                  apiaFilter.dateRequired &&
                  isEmpty(apiaFilter.currentValue) &&
                  isEmpty(apiaFilter.filterToValue)
                ) {
                  return setError(
                    innerFilter,
                    'error',
                    true,
                    'Filtro requerido',
                  );
                } else if (
                  apiaFilter.dateToRequired &&
                  isEmpty(apiaFilter.filterToValue)
                ) {
                  return setError(
                    innerFilter,
                    'errorTo',
                    true,
                    'Filtro requerido',
                  );
                } else if (
                  apiaFilter.dateFromRequired &&
                  !isEmpty(apiaFilter.currentValue)
                ) {
                  return setError(innerFilter, 'errorFrom', false);
                } else if (
                  apiaFilter.dateRequired &&
                  !isEmpty(apiaFilter.currentValue) &&
                  !isEmpty(apiaFilter.filterToValue)
                ) {
                  return setError(innerFilter, 'error', false);
                } else if (
                  apiaFilter.dateToRequired &&
                  !isEmpty(apiaFilter.filterToValue)
                ) {
                  return setError(innerFilter, 'errorTo', false);
                } else {
                  return innerFilter;
                }
              } else {
                return innerFilter;
              }
            } else {
              const { apiaFilter } = innerFilter;

              if (apiaFilter.required) {
                if (isEmpty(apiaFilter.currentValue)) {
                  return setError(
                    innerFilter,
                    'error',
                    true,
                    'Filtro requerido',
                  );
                } else {
                  return setError(innerFilter, 'error', false);
                }
              } else {
                return innerFilter;
              }
            }
          })) ?? [];

  if (
    missingFilters.some(
      (current) => typeof current.apiaFilter.error === 'string',
    )
  ) {
    const firstMissingFilterId = missingFilters.find(
      (current) => typeof current.apiaFilter.error === 'string',
    )?.apiaFilter.id;

    const filterElement = document.querySelector(
      `[name="${firstMissingFilterId as string}"]`,
    ) as HTMLElement;
    if (filterElement) {
      filterElement.dispatchEvent(makeCustomEvent('focus'));
      filterElement.focus();
    }
  }

  return missingFilters;
}
